export interface SearchUserInput {
  firstName?: string;
  lastName?: string;
  email?: string;
  pageSize?: number;
  offset?: number;
}
